<div [ngClass]="containerClass()" [class]="styleClass ?? ''" [ngStyle]="style" [attr.aria-labelledby]="ariaLabelledBy" [attr.aria-label]="ariaLabel" [attr.data-pc-name]="'avatar'">
    <ng-content></ng-content>
    <img [src]="imageUrl" *ngIf="imageUrl; else iconTemplate" (error)="imageError($event)" [attr.aria-label]="ariaLabel"  alt="Profile picture"/>
    <ng-template #iconTemplate><span [class]="icon" [ngClass]="'p-avatar-icon'" *ngIf="icon; else textTemplate"></span></ng-template>
    <ng-template #textTemplate><span class="p-avatar-text" *ngIf="label">{{ label }}</span></ng-template>
</div>
